import HeaderMain from "../comp/head-navs-main";
import ViewContent from "../comp/view-content";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import UserBalanceCard from "../comp/user-balancecard";
import BusinessActions from "../comp/bsnx-actions";

export default function Home() {


  return (
    <>
      <HeaderMain />
      <ViewContent 
        content={
          <>
            <ViewDividerSmall />
            <UserBalanceCard />
            <BusinessActions />

            <ViewDividerMedium />            
            <ViewSectionName data={'My Team'}/>


            <ViewDividerMedium />
            <ViewDividerMedium />
          </>
        }
      />
      

    </>
  )
}